import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.country)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass([_ctx.country.iso2.toLowerCase(), "v3q_tel__flag"])
      }, null, 2))
    : _createCommentVNode("", true)
}